"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Hero() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.to(".bg-photo", {
        yPercent: -12,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top top",
          end: "bottom top",
          scrub: true
        }
      });
      gsap.to(".eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        delay: 0.4,
        ease: "power3.out"
      });
      gsap.set(".headline", {
        y: 24,
        filter: "blur(8px)"
      });
      gsap.to(".headline", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.9,
        delay: 0.5,
        ease: "power3.out"
      });
      gsap.set(".mission-body", {
        y: 20
      });
      gsap.to(".mission-body", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        delay: 0.9,
        ease: "power3.out"
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".eyebrow", ".headline", ".mission-body"], {
        opacity: 1,
        y: 0,
        filter: "blur(0px)"
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return;
}